define(function (require, exports, module) {
    'use strict';

    const uid = require('../uid');
    const uploadLog = require('../../uploadLog');
    const UploadLogRecord = require('../../UploadLogRecord');
    const uploadRadar = require('../../uploadRadar');
    const fileSystemPath = require('./fileSystemPath');
    const AsyncIterator = require('../async/AsyncIterator');
    const UploadDescriptor = require('../../UploadDescriptor');
    const { sendGaUploader } = require('reactApp/modules/uploadList/uploadList.helpers');
    
    /**
     * @namespace
     */
    const fileSystemFileHelper = {
        /**
         * @param {File} file
         * @returns {UploadDescriptor}
         */
        createDescriptor: function (file) {
            const radar = uploadRadar.create();
            const localName = fileSystemPath.normalize(file.name);
            const relativePath = fileSystemPath.normalize(file.webkitRelativePath) || localName;
            const localPath = `/${relativePath}`;
            const size = file.size;
            const id = uid();
            const attributes = {
                id: id,
                file: file,
                localName: localName,
                localPath: localPath,
                isFile: true,
                isDirectory: false,
                isUnreadDirectory: false,
                radar: radar,
            };

            if (fileSystemPath.isIgnoredFileName(localName)) {
                sendGaUploader('file', 'ignored_file');
                return null;
            }

            const descriptor = new UploadDescriptor(attributes);

            descriptor.set('size', size, {
                silent: true,
            });

            radar.add('kind-file', 0);
            radar.add('state-pending', 0);
            radar.add('size', size);
            uploadLog.info(
                {
                    id: id,
                    type: 'file',
                    kind: 'file',
                    size: size,
                    localPath: localPath,
                },
                UploadLogRecord.LEVEL_IMPORTANT
            );

            return descriptor;
        },

        /**
         * Use in AsyncIterator
         * @param {File} file
         * @param {number} index
         * @param {FileList|Array.<File>} files
         * @param {Function} next
         */
        _createDescriptor: function (file, index, files, next) {
            // @type {Array.<UploadDescriptor>}
            const descriptors = this;

            if (file instanceof File) {
                // @type {UploadDescriptor}
                const descriptor = fileSystemFileHelper.createDescriptor(file);
                if (descriptor) {
                    descriptors.push(descriptor);
                }
            }

            next(descriptors);
        },

        /**
         * @param {Array.<File>} files
         * @returns {Promise}
         * @resolves {Array.<UploadDescriptor>}
         * @rejects {Error}
         */
        getDescriptors: function (files) {
            // @type {Array.<UploadDescriptor>}
            const descriptors = [];
            const promise = new AsyncIterator(files, fileSystemFileHelper._createDescriptor, descriptors);

            return promise;
        },
    };

    module.exports = fileSystemFileHelper;
});
